export default __webpack_public_path__ + "static/media/36I-102622_-15517_0.2f80c6ba.jpg";